// this file is used to call public api
import APIService from './APIService';
import config from '../../config';
import { objectToQueryParams } from '../helpers/common';
export default class PublicAPIService extends APIService {
  /**
   * Service Status
   */
  static getServiceStatus() {
    const url = config.baseUrlForMTAServiceStatus;
    return this.get(`${url}/service-status`);
  }
  /**
   *
   * @param {object} queryParams
   */
  static getSearchedData(queryParams) {
    const params = objectToQueryParams(queryParams);
    const url = `${config.baseUrlForHelp}?${params}`;
    return this.get(url, null, { Authorization: config.HelpServiceAuth });
  }
  static getUserRegisterStepStatus(email,status) {
    let url;
    if (status) {
      url = `${config.baseUrlForUserOrg}/verify/email/${email}?signUpStep=${status}`;
    }else {
      url = `${config.baseUrlForUserOrg}/verify/email/${email}`;
    }
    return this.get(url);
  }
}
